<template>
  <div class="home" :class="{ isMobile }">
    <el-carousel :height="`${isMobile ? 470 : 940}px`" class="top-banner">
      <el-carousel-item v-for="(item, i) in pageData.banner" :key="i">
        <div class="banner">
          <img :src="item.icon" />
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="about-warpper" v-if="pageData.company">
      <div class="info-box page-width-warpper">
        <div class="info-left">
          <Title title="走进华武" en="ABOUT US" align="left" />
          <h2>{{ pageData.company.companyName }}</h2>
          <p>{{ pageData.company.companyDescription }}</p>
          <ul>
            <li>
              <div class="count">
                <span>{{ pageData.company.factoryArea }}</span
                >㎡
              </div>
              工厂面积
            </li>
            <li>
              <div class="count">
                <span>{{ pageData.company.companyMoney }}</span
                >万元
              </div>
              企业注册资金
            </li>
            <li>
              <div class="count">
                <span>{{ pageData.company.companyProduction }}</span
                >万元
              </div>
              企业产值
            </li>
          </ul>
          <div class="btn">
            <my-button @click.native="$router.push(`/about`)"
              >查看更多</my-button
            >
          </div>
        </div>
        <div class="info-right">
          <img
            class="image"
            :src="
              pageData.company.companyLooksPhoto &&
              pageData.company.companyLooksPhoto.split(',')[0]
            "
          />
        </div>
      </div>
    </div>
    <div class="swiper-warpper">
      <Title title="产品中心" en="PRODUCT CENTER" />
      <div class="products page-width-warpper">
        <ul>
          <li
            v-for="(item, j) in pageData.productIntroduce"
            :key="j"
            :style="{ backgroundImage: `url(${item.icon})` }"
            @click="$router.push(`/product`)"
          >
            <div class="back">
              <div class="name">{{ item.title }}</div>
              <p>{{ item.summary }}</p>
            </div>
          </li>
        </ul>
        <div class="more">
          <my-button @click.native="$router.push('/product')"
            >查看全部</my-button
          >
        </div>
      </div>
    </div>
    <div class="dominant-warpper">
      <ul>
        <li
          v-for="(item, i) in dominantList"
          :key="i"
          @mouseover="mouseover(i)"
          :class="{ active: dominantCurrent === i }"
          :style="{ backgroundImage: `url(${item.back})` }"
        >
          <div class="item-warpper">
            <div class="icon">
              <img :src="dominantCurrent !== i ? item.icon : item.icon2" />
            </div>
            <h2>{{ item.name }}</h2>
            <p>{{ item.en }}</p>
            <div class="text" v-if="dominantCurrent === i">{{ item.text }}</div>
            <img
              v-if="dominantCurrent !== i"
              class="arrow"
              src="@/assets/images/home/arrow.png"
            />
            <img v-else class="arrow" src="@/assets/images/home/arrow2.png" />
          </div>
        </li>
      </ul>
    </div>
    <div class="company-warpper page-width-warpper">
      <Title title="合作厂商" en="Cooperative manufacturers" align="left" />
      <ul>
        <li
          v-for="(item, i) in pageData.friendlyLink"
          :key="i"
          @click="toPath(item.summary)"
        >
          <img :src="item.icon" />
        </li>
      </ul>
      <Title title="产品应用" en="Product Application" align="left" />
    </div>
    <div class="project-warpper">
      <ul class="page-width-warpper">
        <li v-for="(item, i) in projectList" :key="i">
          <div class="icon">
            <img :src="item.icon" />
          </div>
          <h2>{{ item.name }}</h2>
          <p>{{ toUpperCase(item.en) }}</p>
        </li>
      </ul>
    </div>
    <News :list="pageData.news" />
    <!-- <LeaveWord /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Title from "./components/Title.vue";
import News from "./components/News.vue";
import LeaveWord from "./components/LeaveWord.vue";
import MyButton from "@/components/MyButton.vue";
import { getIndex } from "@/api/index";

export default {
  name: "Home",
  components: {
    Title,
    News,
    LeaveWord,
    MyButton,
  },
  data() {
    return {
      dominantList: [
        {
          name: "地理位置优势",
          en: "GEOGRAPHIC LOCATION",
          text: "地理位置优越，交通便利",
          icon: require("@/assets/images/home/dominant1.png"),
          icon2: require("@/assets/images/home/dominant1_w.png"),
          back: require("@/assets/images/home/dominant_back1.png"),
        },
        {
          name: "生产设备优势",
          en: "PRODUCTION EQUIPMENT",
          text: "铸就行业品质典范",
          icon: require("@/assets/images/home/dominant2.png"),
          icon2: require("@/assets/images/home/dominant2_w.png"),
          back: require("@/assets/images/home/dominant_back2.png"),
        },
        {
          name: "研发与人才优势",
          en: "R&D and Talent",
          text: "成立研发中心，组建研发队伍",
          icon: require("@/assets/images/home/dominant3.png"),
          icon2: require("@/assets/images/home/dominant3_w.png"),
          back: require("@/assets/images/home/dominant_back3.png"),
        },
      ],
      dominantCurrent: 1,
      projectList: [
        {
          name: "民生工程",
          en: "Civil Engineering",
          icon: require("@/assets/images/home/project1.png"),
        },
        {
          name: "新能源工程",
          en: "new energy",
          icon: require("@/assets/images/home/project2.png"),
        },
        {
          name: "电网建设工程",
          en: "power grid",
          icon: require("@/assets/images/home/project3.png"),
        },
        {
          name: "轨道交通工程",
          en: "Rail Transit",
          icon: require("@/assets/images/home/project4.png"),
        },
        {
          name: "工业制造",
          en: "industry",
          icon: require("@/assets/images/home/project5.png"),
        },
      ],
      newsCurrent: 0,
      newsList: [],
      pageData: {},
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    toUpperCase(en) {
      if (!en) return "";
      return en.toUpperCase();
    },
    mouseover(i) {
      this.dominantCurrent = i;
      console.log(i);
    },
    getData() {
      getIndex().then((res) => {
        this.pageData = res.data;
      });
    },
    toPath(path) {
      if (!path) return;
      if (path.indexOf("http") === 0) {
        window.open(path, "_blank");
      } else {
        this.$router.push({ path });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.el-carousel {
  ::v-deep .el-carousel__indicator--horizontal {
    padding: 0 4px;
    .el-carousel__button {
      height: 6px;
      width: 32px;
      transform: skewX(-30deg); /* 倾斜角度 */
    }
  }
  &.top-banner {
    ::v-deep .el-carousel__indicator--horizontal {
      padding: 12px 4px;
    }
  }
}
.home {
  overflow: hidden;
  &.isMobile {
    .banner {
      height: 470px;
    }
    .about-warpper {
      padding: 22px 0;
      .info-box {
        display: block;
        .info-left {
          padding: 0;
          h2 {
            font-size: 18px;
          }
          p {
            margin-top: 12px;
            font-size: 12px;
          }
          .btn {
            margin-top: 22px;
            display: flex;
            justify-content: center;
          }
          ul {
            padding: 17px 28px 0;
            font-size: 10px;
            li {
              .count {
                margin-bottom: 10px;
                span {
                  font-size: 32px;
                }
              }
            }
          }
        }
        .info-right {
          margin-left: 0;
          width: 100%;
          height: 200px;
          img {
            margin-top: 15px;
            border-radius: 12px;
            object-fit: cover;
          }
        }
      }
    }
    .swiper-warpper {
      padding: 0;
      .products {
        padding-top: 21px;
        .more {
          top: -3px;
        }
        ul {
          display: block;
          margin-top: 13px;
          li {
            height: 60px;
            margin-left: 0;
            margin-top: 12px;
            background-position: left center;
            background-size: 120px;
            color: #333;
            .back {
              position: absolute;
              top: 0;
              left: 130px;
              right: 0;
              height: 100%;
              padding: 0;
              background: none;
            }
            .name {
              font-size: 18px;
            }
            p {
              @include clamp(1);
              margin-top: 12px;
            }
          }
        }
        .more {
          margin-top: 20px;
        }
      }
    }
    .dominant-warpper {
      margin-top: 20px;
      ul {
        li {
          .item-warpper {
            height: 360px;
            padding: 30px 10px;
            text-align: center;
          }
          .icon {
            width: 34px;
            height: 32px;
            margin: 0 auto;
          }
          h2 {
            width: 100%;
            margin-top: 18px;
            font-size: 15px;
          }
          .text {
            margin-top: 20px;
            font-size: 12px;
          }
          p {
            margin-top: 8px;
            font-size: 10px;
          }
          .arrow {
            margin: 30px auto 0;
            width: 26px;
            height: 9px;
          }
        }
      }
    }
    .company-warpper {
      margin-top: 30px;
      margin-bottom: 20px;
      ul {
        margin-top: 20px;
        margin-bottom: 30px;
        li {
          width: 33.3%;
          height: 65px;
          &:hover {
            &:hover {
              transform: translateX(-6px) translateY(-6px);
            }
          }
        }
      }
    }
    .project-warpper {
      height: 400px;
      padding-bottom: 0;
      ul {
        li {
          width: 47%;
          height: 120px;
          .icon {
            width: 44px;
            height: 36px;
          }
          h2 {
            margin-top: 12px;
            font-size: 14px;
          }
          p {
            margin-top: 8px;
            font-size: 10px;
          }
        }
      }
    }
  }
  .banner {
    height: 940px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center bottom;
    }
  }
  .about-warpper {
    background: url(../../assets/images/home/about_back.png) center center
      no-repeat;
    background-size: auto 100%;
    padding: 60px 0;
    .info-box {
      position: relative;
      display: flex;
      .info-left {
        flex: 1;
        h2 {
          margin-top: 1.3em;
          font-size: 32px;
          color: #333333;
          font-weight: bold;
          line-height: 1.3em;
        }
        p {
          margin-top: 1.3em;
          font-size: 16px;
          color: #3d3d3d;
          line-height: 2em;
          @include clamp(4);
        }
        .btn {
          margin-top: 40px;
        }
        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 30px 50px 0 0;
          text-align: center;
          font-size: 16px;
          color: #3d3d3d;
          line-height: 1;
          li {
            .count {
              margin-bottom: 16px;
              span {
                font-size: 48px;
                color: #3881f8;
                line-height: 1;
                font-weight: bold;
              }
            }
          }
        }
      }
      .info-right {
        width: 671px;
        height: 517px;
        margin-left: 30px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .swiper-warpper {
    padding: 60px 0;
    .products {
      position: relative;
      .more {
        display: flex;
        justify-content: center;
        margin-top: 40px;
      }
      ul {
        display: flex;
        margin-top: 40px;
        li {
          flex: 1;
          height: 418px;
          margin-left: 35px;
          position: relative;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          overflow: hidden;
          color: #333;
          box-shadow: 0px 6px 18px 0px rgba(51, 51, 51, 0.06);
          border-radius: 4px;
          transition: all 0.5s;
          cursor: pointer;
          &:first-child {
            margin-left: 0;
          }
          &:hover {
            transform: scale(1.04);
            .name {
              color: $main-color;
              text-decoration: underline;
            }
          }
          .back {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 120px;
            padding: 20px 18px 0;
            background: #fff;
            // transition: top 0.4s;
          }
          .name {
            font-weight: bold;
            font-size: 18px;
            line-height: 1.2;
            @include clamp(1);
          }
          p {
            @include clamp(2);
            font-size: 14px;
            line-height: 1.7;
            margin-top: 1em;
          }
        }
      }
    }
  }
  .dominant-warpper {
    margin-top: 60px;
    ul {
      display: flex;
      li {
        flex: 1;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        &.active {
          .item-warpper {
            justify-content: flex-start;
            align-items: flex-start;
            color: #fff;
            background: none;
          }
        }
        .item-warpper {
          height: 790px;
          box-sizing: border-box;
          padding: 100px 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #333;
          line-height: 1;
          // transition: all 0.5s;
          background: rgba(255, 255, 255, 0.9);
        }
        .icon {
          width: 54px;
          height: 52px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        h2 {
          margin-top: 30px;
          font-weight: bold;
          font-size: 24px;
        }
        .text {
          margin-top: 40px;
          font-size: 20px;
        }
        p {
          margin-top: 14px;
          font-size: 16px;
        }
        .arrow {
          margin-top: 60px;
          display: block;
          width: 42px;
          height: 14px;
        }
      }
    }
  }
  .company-warpper {
    margin-top: 60px;
    margin-bottom: 40px;
    ul {
      margin-top: 40px;
      margin-bottom: 60px;
      display: flex;
      flex-wrap: wrap;
      li {
        width: 216px;
        height: 110px;
        transition: all 0.5s;
        // overflow: hidden;
        &:hover {
          &:hover {
            z-index: 2;
            transform: translateX(-10px) translateY(-10px);
            box-shadow: 10px 10px 10px rgba($color: #000000, $alpha: 0.2);
          }
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .project-warpper {
    background: url(../../assets/images/home/project_back.png) center center
      no-repeat;
    background-size: cover;
    height: 840px;
    padding-bottom: 100px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 200px;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: #fff;
        cursor: pointer;
        &:hover {
          background: linear-gradient(90deg, #3881f8 0%, #5da1fe 100%);
        }
        .icon {
          width: 74px;
          height: 60px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        h2 {
          margin-top: 20px;
          font-weight: bold;
          font-size: 24px;
        }
        p {
          margin-top: 14px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
